<template>
  <div class="left-container" :class="menuHide ? 'left-container-hide' : ''" :style="{ width: menuHide ? '80px' : '200px' }">
		<div class="add-container">
			<div @click="handleAdd">
				<Icon type="md-add" />{{ menuHide ? '' : '增加流程' }}
			</div>
		</div>
		<ul class="flow-list">
			<li v-for="item in flows" :key="item.id" :class="{'active': curFlowId==item.id}" class="li-style" @click="handleClick(item.id)">
				<Button class="edit" @click.stop="openEdit(item)" size="small" icon="md-create" type="primary" shape="circle" ></Button>
				<div class="flow-info">
					<div class="flow-name">{{item.name}}</div>
					<div v-if="flowHitStat(item.id)" class="hit-info">
						<span class="hit-percent">到达率 {{ flowHitStat(item.id).percent }}%</span>
					</div>
				</div>
				<Button class="del" @click.stop="delFlowHandler(item.id)" size="small" icon="ios-trash" type="error" shape="circle"></Button>
			</li>
		</ul>
		<Modal
        v-model="showadd"
        title="增加流程"
        @on-ok="ok"
        @on-cancel="cancel"
				:loading="loading"
				width="400px">
				<div class="form">
					<span>流程名称：</span>
					<Input v-model="name" placeholder="" style="width: 250px" />
				</div>
    </Modal>
		<div class="back" @click="menuHideToggle">
			<Icon v-if="menuHide" type="md-arrow-forward" />
			<Icon v-else type="md-arrow-round-back" />
		</div>
	</div>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
  data() {
		return {
			showadd: false,
			name: '',
			editId: 0,
			loading: false,
			menuHide: false,
		}
	},
	computed: {
    ...mapState('flow', [
			'flows', 'curFlowId'
    ]),
    ...mapGetters('flow', ['flowHitStat']),
  },
	methods: {
    ...mapActions('flow', ['switchFlow', 'editFlow', 'delFlow']),
		handleAdd() {
			this.showadd = true
		},
		openEdit(item) {
			this.showadd = true;
			this.editId = item.id;
			this.name = item.name;
		},
		ok() {
			this.loading = true;
			this.editFlow({
				name: this.name,
				id: this.editId,
			}).then((flow) => {
				if (this.editId) return;
				this.handleClick(flow.id)
				this.loading = false;
			}).cancel(() => {
				this.loading = false;
			})
		},
		delFlowHandler(id) {
			this.delFlow(id).then(() => {
				const id = this.flows[0]?.id;
				this.handleClick(id)
			})
		},
		cancel() {
			this.name = '';
			this.editId = 0;
		},
		handleClick(id) {
			this.switchFlow(id)
			this.cancel();
		},
		menuHideToggle() {
			this.menuHide = !this.menuHide;
			console.log('this.menuHide :>> ', this.menuHide);
		}
	}
}
</script>
<style lang="scss" scoped>
.left-container{
	border-right: 1px solid #efefef;
	display: flex;
	flex-direction: column;
}
.flow-list {
	flex: 1;
	overflow-y: auto;
}
li{
	list-style: none;
}
ul{
	width: 200px;
}
.add-container{
	padding: 8px 20px;
	border-bottom: 1px solid #efefef;
	div{
		border-radius: 25px;
		height: 40px;
		padding:  0 20px;
		line-height: 40px;
		background-color: #ff9c00;
		color: #fff;
		cursor: pointer;
	}
}
.li-style{
	height: 90px;
	display: flex;
	align-items: center;
  justify-content: center;
	border: 1px solid #efefef;
	margin: 10px 20px;
	box-shadow: 0 0 20px #dedede;
	position: relative;
	border-radius: 8px;
	cursor: pointer;
}
.flow-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
}
.flow-name {
	font-size: 14px;
	line-height: 1.2;
	word-break: break-all;
}
.hit-info {
	display: flex;
	gap: 6px;
	font-size: 12px;
	line-height: 1;
}
.hit-percent {
	color: #ff9c00;
	font-weight: 600;
}
.li-style.active .hit-percent {
	color: #fff;
}
.li-style:hover .del{
	display: block;
}
.li-style:hover .edit{
	display: block;
}
.del{
	position: absolute;
	right: -10px;
	top: -10px;
	display: none;
	background-color: #ff6c6c;
}
.edit{
	position: absolute;
	right: -10px;
	bottom: -10px;
	display: none;
}
.form{
	padding-bottom: 20px;
}
.active{
	background-color: #7f9fd5;
	color: #fff;
}
.back {
	line-height: 30px;
	cursor: pointer;
}

.left-container-hide {
	font-size: 12px;
	.add-container {
		padding: 10px;
	}
	ul{
		width: 80px;
	}
	.li-style {
		min-height: 50px;
		height: auto;
		padding: 5px;
		margin: 5px;
	}
}
</style>
